import {
  Cartographic,
  TerrainProvider,
  sampleTerrainMostDetailed,
} from 'cesium';

/**
 * Sample terrain heights for many positions in one batched request. Must run on
 * the main thread (needs the live terrain provider); pass the resulting heights
 * into workers for geometry building.
 *
 * Mutates and returns the input Cartographics with `.height` filled. Falls back
 * to 0 on failure so callers always get usable values.
 */
export async function sampleHeights(
  terrain: TerrainProvider,
  positions: Cartographic[],
): Promise<Cartographic[]> {
  if (positions.length === 0) return positions;
  try {
    return await sampleTerrainMostDetailed(terrain, positions);
  } catch (err) {
    console.warn('[terrain] sampleTerrainMostDetailed failed; using 0', err);
    for (const p of positions) p.height = p.height ?? 0;
    return positions;
  }
}
